import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import Block from "./Block"

import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    horizontalListSortingStrategy,
    useSortable,
    verticalListSortingStrategy
} from '@dnd-kit/sortable';

import { CSS } from '@dnd-kit/utilities';
import { useHomePageSetting } from '..';

const service = new StoreSettingService();



const BlocksEditor = ({ data, onChange }) => {


    const [blocks, setBlocks] = useState([])
    const { editItem, showEditItem, hideEditItem } = useHomePageSetting();
    const sensor = useSensor(PointerSensor, {
        activationConstraint: {
            distance: 10,
        },
    });

    useEffect(() => {
        setBlocks(data)
    }, [data])


    const onBlockChange = (block) => {


        if (block.id) {
            var i = blocks.findIndex(x => x.id == block.id);
            blocks[i] = block;
            setBlocks([...blocks])
            onChange([...blocks])
        }
    }

    const onDelete = id => {
        var i = blocks.findIndex(x => x.id == id);
        blocks.splice(i, 1)

        setBlocks([...blocks])
        onChange([...blocks])
    }

    const handleDragEnd = (event) => {
        const { active, over } = event;


        if (active.id !== over.id) {
            const oldIndex = blocks.findIndex(x => x.id == active.id);
            const newIndex = blocks.findIndex(x => x.id == over.id);
            var newBlocks = arrayMove(blocks, oldIndex, newIndex);

            setBlocks(newBlocks);
            onChange([...newBlocks])
        }
    }




    return (
        <Space direction='vertical' style={{ width: "100%" }}>

            <DndContext
                sensors={[sensor]}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
            >
                <SortableContext
                    items={blocks}
                    strategy={verticalListSortingStrategy}
                >
                    {blocks.map((x, i) => {
                        return (<SortableItem key={x.id} id={x.id} data={x} onChange={values => onBlockChange(values)} onDelete={onDelete} onShowEdit={e => showEditItem(x.id)} onHideEdit={e => hideEditItem(x.id)} showEdit={editItem == x.id}></SortableItem>)
                    })}
                </SortableContext>
            </DndContext>


        </Space>
    )
}

const SortableItem = (props) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        marginTop: 16,

    };

    return (
        <li ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <Block {...props} ></Block>
        </li>
    );
}
export default BlocksEditor;